export default {
  data () {
    return {
      title: this.$t('billing.cmr.title'),
      subtitle: '',
      description: this.$t('billing.cmr.desc', [5]),
      logo: require('@/assets/plans/cloud.svg'),
    }
  }
};
